import { components } from '@doltech/dto';
import { TestStatusEnum, TestTypeEnum } from '@doltech/utils/lib/constants';
import { Instance } from 'mobx-state-tree';

import { TestResultStore } from '../../student-test-result/model/test-result.store';

export const ViewSolutionStore = TestResultStore.named('ViewSolutionStore')
  .actions((self) => {
    const { init } = self;

    return {
      init(
        data: components['schemas']['TestDetailDTO'] | components['schemas']['TestSectionDTO'],
        testType: TestTypeEnum
      ) {
        let userTestData;
        if (testType === 'PRACTICE_TEST') {
          userTestData = {
            ...data,
            testType,
            testSection: { ...data },
            status: TestStatusEnum.COMPLETED,
          };
        } else {
          userTestData = {
            ...data,
            testType,
            test: { ...data },
            status: TestStatusEnum.COMPLETED,
          };
        }

        init(userTestData);
      },
    };
  })
  .views((self) => ({
    getCorrectAnswersByQuestionType() {
      return self.questions.map(({ correctAnswerKey }) => correctAnswerKey);
    },
    getAnswerKeysByTestSectionIndex(testSectionIndex, viewSolutionLink) {
      const testSection = self.testSections[testSectionIndex];
      const questions = testSection?.getQuestions() || [];

      return questions.map((question) => {
        const { no, correctAnswerKey, correction } = question;

        return {
          no,
          answer: correctAnswerKey,
          explanation: correction?.explanation,
          explanationLink: {
            pathname: viewSolutionLink,
            query: {
              questionNo: no,
            },
          },
        };
      });
    },
  }));

export interface ViewSolutionStoreInstance extends Instance<typeof ViewSolutionStore> {}
